export default __webpack_public_path__ + "static/media/tour3.be786026.png";